import type { Agreement } from "store/agreementsStore";

type TermRef = {
    termId: number;
    workId?: number | null;
    titleId?: number | null;
    beneficiaryId?: number | null;
};

/**
 * Whether an agreement belongs on a term's page. A multi-signature agreement is attached to the
 * main beneficiary's term only: co-beneficiaries find it through the signers of the same work (or of
 * the same title for a term without work). Every agreement also lists its main beneficiary as a
 * signer, so only co-signers count (otherwise the agreement of another term of the same beneficiary
 * would match).
 */
export const isAgreementOfTerm = (
    agreement: Pick<
        Agreement,
        "relatedResource" | "relatedResourceId" | "workId" | "titleId" | "beneficiaryId" | "beneficiarySignerIds"
    >,
    { termId, workId, titleId, beneficiaryId }: TermRef,
) => {
    if (agreement.relatedResource !== "term") return false;
    if (+agreement.relatedResourceId === +termId) return true;
    if (!beneficiaryId) return false;

    const sameWork =
        workId != null
            ? agreement.workId != null && +agreement.workId === +workId
            : !!titleId && agreement.titleId != null && +agreement.titleId === +titleId;

    return (
        sameWork &&
        +agreement.beneficiaryId !== +beneficiaryId &&
        !!agreement.beneficiarySignerIds?.includes(+beneficiaryId)
    );
};
